import { lazy } from 'react';
import { openModal } from '@/utils/modals';
import { EmailPreviewModalDataProps } from '@app/pages/profile/components/modals/EmailPreviewModal/types';

const EmailPreviewModal = lazy(() => import('./EmailPreviewModal'));

export const openEmailPreviewModal = (data: EmailPreviewModalDataProps) =>
  openModal(EmailPreviewModal, data);
